<!--材料预约列表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationCode"
          v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
          selectType="selectAssemble"
          :selectData="inventOrg"
          :disabled="isDisableOrganization"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
          @change="inventOrgValueOnChange"
        />
        <global-select
          slot="workshopCode"
          :value.sync="queryParams.workshopCode"
          :selectData="workshopList"
          selectType="selectFilter"
          :selectItem="{ value: 'workshopCode', label: 'workshopDesc' }"
        />
        <global-select
          slot="businessType"
          :value.sync="queryParams.businessType"
          :selectData="businessTypeList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiBomProductionScheduleAttributeCcExport" ref="download" />
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="() => handleOk(false)" />
        <create-modal ref="createModalRef" @refresh="handleOk" />
        <a-button v-hasPermi="['bom:attributeMaintenance:add']" type="primary" :loading="loading" @click="onCreate">新增</a-button>
        <a-button v-hasPermi="['bom:attributeMaintenance:remove']" :loading="loading" @click="onDelete">删除</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:attributeMaintenance:import']" @click="handleImport">导入</a-button>
        <a-button type="primary" :loading="loading" v-hasPermi="['bom:attributeMaintenance:export']" @click="handleExport">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
          <template slot="booleanEditor" slot-scope="{ record, text, column }">
            <span v-if="!isEdit || currentId !== record.id">{{ statusFormat(text) }}</span>
            <a-select v-else v-model="record[column.key]" placeholder="请选择" class="pub-select">
              <a-select-option value="Y">是</a-select-option>
              <a-select-option value="N">否</a-select-option>
            </a-select>
          </template>
          <!-- 揉单天数 -->
          <template slot="mixOrderNum" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input-number v-else v-model="record.mixOrderNum" :precision="0" :min="1"/>
          </template>
          <!-- 生产提前期 -->
          <template slot="produceLeadTime" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input-number v-else v-model="record.produceLeadTime" :precision="0"/>
          </template>
          <!-- 业务简称 -->
          <template slot="businessShortName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <a-input v-else v-model="record.businessShortName" placeholder="请输入" :maxLength="40" />
          </template>
          <!-- 供应类型  -->
          <template slot="supplyTypeName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              v-model="record.supplyType"
              :selectData="supplyTypeList"
              selectType="selectFilter"
              :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
            />
          </template>
          <!-- 供应子库名称 -->
          <template slot="supplySublibraryName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              searchParam="supplySublibrary"
              selectType="selectAssembleSearch"
              :value.sync="record.supplySublibrary"
              requestApi="/inv/invCallRequestLines/intoSublibraryBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ 'organizationCode': record.organizationCode }"
            />
          </template>
          <!-- 完工子库名称 -->
          <template slot="completedSublibraryName" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              searchParam="completedSublibrary"
              selectType="selectAssembleSearch"
              :value.sync="record.completedSublibrary"
              requestApi="/inv/invCallRequestLines/intoSublibraryBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ 'organizationCode': record.organizationCode }"
              @change="(val, selectList) => handleCompletedSublibraryChange(val, record)"
            />
          </template>
          <!-- 完工货位 -->
          <template slot="completedLocation" slot-scope="{ record, text }">
            <span v-if="!isEdit || currentId !== record.id">{{ text }}</span>
            <global-select
              v-else
              class="pub-select"
              searchParam="locationCode"
              selectType="selectSearch"
              :value.sync="record.completedLocation"
              requestApi="/inv/invCallRequestLines/intoGoodsAllocationBox"
              :selectItem="{ value: 'realValue', label: 'label' }"
              :setParams="{ 'subinventoryCode': record.completedSublibrary }"
            />
          </template>
          <span slot="operation" slot-scope="text">
            <a
              v-if="(!isEdit || currentId !== text.record.id)"
              v-hasPermi="['bom:attributeMaintenance:edit']"
              @click="handleEdit(text.record)"
            >编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import cacheRequest from '@/mixins/cacheRequest'

import {
  apiBomProductionScheduleAttributeCcList,
  apiBomWorkshopFindList,
  apiBomProductionScheduleAttributeCcUpdate,
  apiBomProductionScheduleAttributeCcExport,
  apiBomProductionScheduleAttributeCcDel
 } from '@/api/mes/productionPrepare/attributeMaintenance'
import createModal from './components/create-modal.vue'
import ImportExcel from "@/components/ImportExcel/importExcel"

import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'AttributeMaintenance',
  components: { DownloadModal, createModal, ImportExcel },
  mixins: [cacheSearch, cacheRequest],
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    }),
    isDisableOrganization() {
      return this.organizationCodeOrigin !== 'A001'
    },
    // 用户导入参数
    upload() {
      return {
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomProductionScheduleAttributeCc/import?orgNo=' + this.organizationCodeOrigin
      }
    }
  },
  data() {
    return {
      apiBomProductionScheduleAttributeCcExport,
      loading: false, // 请求loading
      isEdit: false,
      currentId: '',
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiBomProductionScheduleAttributeCcList, false),
        pageCurrent: true
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'bom/bomProductionScheduleAttributeCc/template',
        name: `排产属性导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      workshopList: [], // 车间列表
      statusList: [], // 状态列表
      businessTypeList: [], // 业务类型列表
      supplyTypeList: [], // 供应类型列表
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        workshopCode: undefined,
        businessType: undefined
      },
      formList: [
        { label: '组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '车间', decorator: ['workshopCode'], type: 'workshopCode' },
        { label: '业务类型', decorator: ['businessType'], type: 'businessType' }],
      // 表格字段
      columns: [
        { title: '组织', dataIndex: 'organizationName', align: 'center', width: 200 },
        { title: '车间', dataIndex: 'workshopName', align: 'center', width: 140 },
        { title: '业务类型', dataIndex: 'businessTypeName', align: 'center', width: 140 },
        {
          title: '生产提前期',
          dataIndex: 'produceLeadTime',
          scopedSlots: {
            customRender: 'produceLeadTime'
          },
          align: 'center',
          width: 160
        },
        { title: '业务简称', dataIndex: 'businessShortName', scopedSlots: { customRender: 'businessShortName' }, align: 'center', width: 140 },
        { title: '是否揉单', dataIndex: 'mixOrderFlag', align: 'center', scopedSlots: { customRender: 'booleanEditor' }, width: 140 },
        { title: '揉单天数', dataIndex: 'mixOrderNum', align: 'center', width: 100, scopedSlots: { customRender: 'mixOrderNum' } },
        { title: '是否合并叫料', dataIndex: 'combineCallRequestFlag', align: 'center', scopedSlots: { customRender: 'booleanEditor' }, width: 100 },
        { title: '是否联动车位计划时间', dataIndex: 'linkTimeFlag', align: 'center', scopedSlots: { customRender: 'booleanEditor' }, width: 160 },
        { title: '供应类型', dataIndex: 'supplyTypeName', align: 'center', width: 140, scopedSlots: { customRender: 'supplyTypeName' } },
        { title: '供应子库', dataIndex: 'supplySublibraryName', scopedSlots: { customRender: 'supplySublibraryName' }, align: 'center', width: 240 },
        { title: '完工子库', dataIndex: 'completedSublibraryName', scopedSlots: { customRender: 'completedSublibraryName' }, align: 'center', width: 240 },
        { title: '完工货位', dataIndex: 'completedLocation', scopedSlots: { customRender: 'completedLocation' }, align: 'center', width: 240 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 100 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 140 },
        {
          title: '操作',
          width: 95,
          align: 'center',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    apiBomWorkshopFindList({
      workshopStatus: "Y",
      organizationCode: this.organizationCodeOrigin
    }).then(res => {
      if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
    });
    this.cacheLookupRequest('MES_MO_CC_TYPE', { lookupType: 'MES_MO_CC_TYPE', current: 1, pageSize: 999 }, 'businessTypeList')
    this.cacheLookupRequest('MES_SUPPLY_TYPE', { lookupType: 'MES_SUPPLY_TYPE', current: 1, pageSize: 999, attribute2: 1 }, 'supplyTypeList')
    this.queryParams.organizationCode = this.organizationCodeOrigin;
  },
  mounted() {
    this.onSearch()
  },
  methods: {
    // 子库变化
    handleCompletedSublibraryChange(val, record) {
      record.completedLocation = ''; // 变化完工子库时，清空完工库位
    },
    // 加工组织
    inventOrgValueOnChange (val, status) {
      this.queryParams.workshopCode = '';
      apiBomWorkshopFindList({ organizationCode: val, workshopStatus: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.workshopList = res
        } else {
          this.workshopList = []
        }
      })
    },
    // 行选中
    selectedRowChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    statusFormat (val) {
      return val === 'Y' ? '是' : val === 'N' ? '否' : '';
    },
    // 编辑
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return
      }
      this.isEdit = true
      this.currentId = record.id
    },
    // 保存
    handleSave(record) {
      if (typeof record.produceLeadTime === 'undefined') {
        this.$message.warning('请输入生产提前期')
        return
      }
      if (!record?.businessShortName) {
        this.$message.warning('请输入业务简称')
        return
      }
      if (typeof record.mixOrderFlag === 'undefined') {
        this.$message.warning('请输入是否揉单')
        return
      }
      if (typeof record.combineCallRequestFlag === 'undefined') {
        this.$message.warning('请输入是否合并叫料')
        return
      }
      if (!record?.supplyType) {
        this.$message.warning('请输入供应类型')
        return
      }
      this.loading = true

      apiBomProductionScheduleAttributeCcUpdate(record)
        .then((res) => {
          if (res?.code === 200) {
            this.$message.success('编辑成功')
            this.handleOk(true)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 取消
    handleCancel() {
      this.handleOk(true)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      this.isEdit = false
      this.currentId = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.setSearchCache(params) // 设置缓存
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        organizationCode: this.organizationCodeOrigin,
        workshopCode: undefined,
        businessType: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 新增物料
    onCreate() {
      this.$refs.createModalRef.show()
    },
    // 删除
    onDelete() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const self = this
      self.$confirm({
        title: '提示',
        content: '请确认是否删除勾选单据？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          self.loading = true;
          const ids = self.selectedRows.map(item => item.id).join(',')
          apiBomProductionScheduleAttributeCcDel(ids).then(res => {
            if (res?.code === 200) {
              self.$message.success(res?.msg || '操作成功')
              self.handleOk()
            }
          }).finally(() => {
            self.loading = false;
          })
        }
      })
    },
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.pub-select {
  /deep/ .ant-select {
    width: 100%;
  }
}
</style>
